// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*.coverphoto img {\n\tmax-width: 100%;\n\theight: auto;\n\tdisplay: block;\n\tmargin: auto;\n\tmin-height: 400px;\n}*/\n\n.coverphoto {\n\tmax-width: 100%;\n\theight: auto;\n\tmin-height: 400px;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n}", ""]);
// Exports
module.exports = exports;
